var _filter, _rect, _rect2, _text, _rect3, _text2, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgAutocannon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 320",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0f1a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flagGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "descGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e1e3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2a2a4a"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 320,
    rx: 16,
    fill: "url(#bgGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 320,
    rx: 16,
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 45,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 18,
    fontWeight: 700,
    opacity: 0
  }, "\n    \u26A1 Autocannon Command Breakdown\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    fill: "freeze"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 620,
    height: 40,
    rx: 8,
    fill: "#12121f",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.3s",
    fill: "freeze"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 85,
    fill: "#10b981",
    fontSize: 13,
    fontFamily: "'Fira Code', 'Cascadia Code', monospace",
    opacity: 0
  }, "\n    $ autocannon ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#f472b6"
  }, "-c 1000"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#38bdf8"
  }, "-p 10"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#fbbf24"
  }, "-d 10"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#94a3b8"
  }, "http://localhost:3000/simple"), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.5s",
    fill: "freeze"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 120,
    height: 50,
    rx: 10,
    fill: "url(#flagGrad)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 140,
    to: 120,
    dur: "0.5s",
    begin: "0.8s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 140,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "'Fira Code', monospace"
  }, "\n      -c 1000\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 160,
    to: 140,
    dur: "0.5s",
    begin: "0.8s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 158,
    textAnchor: "middle",
    fill: "#e0d4ff",
    fontSize: 10
  }, "\n      flag\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 178,
    to: 158,
    dur: "0.5s",
    begin: "0.8s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 145,
    x2: 190,
    y2: 145,
    stroke: "#6c63ff",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 20,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 120,
    width: 470,
    height: 50,
    rx: 10,
    fill: "url(#descGrad)",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 143,
    fill: "#f472b6",
    fontSize: 14,
    fontWeight: 600
  }, "1000 Concurrent Connections"), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 162,
    fill: "#94a3b8",
    fontSize: 11
  }, "Simulates 1000 users hitting the server simultaneously"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 185,
    width: 120,
    height: 50,
    rx: 10,
    fill: "url(#flagGrad)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 205,
    to: 185,
    dur: "0.5s",
    begin: "1.2s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 205,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "'Fira Code', monospace"
  }, "\n      -p 10\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 225,
    to: 205,
    dur: "0.5s",
    begin: "1.2s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 223,
    textAnchor: "middle",
    fill: "#e0d4ff",
    fontSize: 10
  }, "\n      flag\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 243,
    to: 223,
    dur: "0.5s",
    begin: "1.2s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 210,
    x2: 190,
    y2: 210,
    stroke: "#6c63ff",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 20,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 185,
    width: 470,
    height: 50,
    rx: 10,
    fill: "url(#descGrad)",
    stroke: "#38bdf8",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 208,
    fill: "#38bdf8",
    fontSize: 14,
    fontWeight: 600
  }, "10 Pipelining Requests"), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 227,
    fill: "#94a3b8",
    fontSize: 11
  }, "Each connection sends 10 requests in pipeline (without waiting)"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.6s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 250,
    width: 120,
    height: 50,
    rx: 10,
    fill: "url(#flagGrad)",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 270,
    to: 250,
    dur: "0.5s",
    begin: "1.6s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 270,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "'Fira Code', monospace"
  }, "\n      -d 10\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 290,
    to: 270,
    dur: "0.5s",
    begin: "1.6s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 288,
    textAnchor: "middle",
    fill: "#e0d4ff",
    fontSize: 10
  }, "\n      flag\n      ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    from: 308,
    to: 288,
    dur: "0.5s",
    begin: "1.6s",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 275,
    x2: 190,
    y2: 275,
    stroke: "#6c63ff",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 20,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 250,
    width: 470,
    height: 50,
    rx: 10,
    fill: "url(#descGrad)",
    stroke: "#fbbf24",
    strokeWidth: 1,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 273,
    fill: "#fbbf24",
    fontSize: 14,
    fontWeight: 600
  }, "10 Seconds Duration"), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 292,
    fill: "#94a3b8",
    fontSize: 11
  }, "The benchmark runs for 10 seconds before reporting results"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAutocannon);
export default __webpack_public_path__ + "static/media/svg-autocannon.eb8c575ea0c26e40f8faf5bba39b4952.svg";
export { ForwardRef as ReactComponent };